import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ConfigService } from 'app/core/services/config.service';
import { Observable } from 'rxjs';
import { AccountService } from '../../account.service';

@Component({
  selector: 'itpx-update-seller-account',
  templateUrl: './update-seller-account.component.html',
  styleUrls: ['./update-seller-account.component.css']
})
export class UpdateSellerAccountComponent implements OnInit {

  @Input() details: any;
  @Output() onSave = new EventEmitter<any>();
  form: FormGroup;
  currencyDict: Observable<any[]>;
  private cancelRoute: string = '/agora/account-data/accounts';

  constructor(
    private fb: FormBuilder,
    private service: AccountService,
    private configService: ConfigService  
  ) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
        id: [this.details.id, [Validators.required]],
        aboutSeller: this.details.aboutSeller,
        supportEmail: [this.details.supportEmail, [Validators.required, Validators.pattern(this.configService.get('validators').email)]],
        examFulfilmentEmail: [this.details.examFulfilmentEmail, [Validators.required, Validators.pattern(this.configService.get('validators').email)]],
        manualDeliveryEmail: [this.details.manualDeliveryEmail, [Validators.required, Validators.pattern(this.configService.get('validators').email)]],
        sellerProceedsCurrency: [this.details.sellerProceedsCurrency.id, Validators.required],
        fixed: this.details.fixed,

        instructorSellerProceedsMax: [this.details.instructorSellerProceedsMax, Validators.required],
        instructorSellerProceedsMin: [this.details.instructorSellerProceedsMin, Validators.required],
        instructorSellerProceedsPercent: [this.details.instructorSellerProceedsPercent, [Validators.required, this.validatePercent.bind(this)]],
        nonHostedSellerProceedsMax: [this.details.nonHostedSellerProceedsMax, Validators.required],
        nonHostedSellerProceedsMin: [this.details.nonHostedSellerProceedsMin, Validators.required],
        nonHostedSellerProceedsPercent: [this.details.nonHostedSellerProceedsPercent, [Validators.required, this.validatePercent.bind(this)]],
        otherSellerProceedsMax: [this.details.otherSellerProceedsMax, Validators.required],
        otherSellerProceedsMin: [this.details.otherSellerProceedsMin, Validators.required],
        otherSellerProceedsPercent: [this.details.otherSellerProceedsPercent, [Validators.required, this.validatePercent.bind(this)]],
        sellerProceedsMax: [this.details.sellerProceedsMax, Validators.required],
        sellerProceedsMin: [this.details.sellerProceedsMin, Validators.required],
        sellerProceedsPercent: [this.details.sellerProceedsPercent, [Validators.required, this.validatePercent.bind(this)]],
    })

    this.currencyDict = this.service.getCurrencyDict().map(_ => _.data);
  }

  save() {
    this.onSave.emit(this.form.value);
  }

  validatePercent(control: AbstractControl) {
    return ( control.value >= 0 && control.value <= 100 ) ? null :
      { custom: { message: 'Not avalid percent' } };
  }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/accounts/edit/update-seller-account/update-seller-account.component.ts